

export default {
  possibleRoles: ['admin', 'basic', 'premium']
}



// WEBPACK FOOTER //
// ./src/config/index.js